<template>
  <div>
    <p>
      masjed.id <strong>("situs dan aplikasi")</strong> dikelola oleh PT MASJED
      INDONESIA DIGITAL <strong>("Kami")</strong>. Untuk melayani kebutuan
      transformasi digital serta menyediakan layanan atas kebutuhan tekologi,
      informasi dan komunikasi (TIK) disektor nirlaba secara umum.
    </p>
    <p>
      Dengan mengunjungi dan/atau menggunakan platform masjed.id, maka baik
      pengunjung maupun pengguna <strong>("Anda")</strong> dinyatakan telah
      memahami dan menyepakati semua isi dalam syarat dan ketentuan di bawah
      ini. Apabila Anda sebagai pengunjung situs tidak menyetujui salah satu,
      sebagian atau seluruh isi syarat dan ketentuan ini, maka Anda tidak
      diperkenankan untuk menggunakan layanan di situs kami.
    </p>
    <p>
      Kami berhak atas kebijakan untuk mengubah atau memodifikasi sebagian atau
      keseluruhan dari isi syarat dan ketentuan ini setiap saat, artinya aturan
      yang berlaku pada halaman ini dapat berubah sewaktu-waktu secara sepihak
      oleh kami, apabila hal tersebut terjadi maka kami akan mencoba memberikan
      pemberitahuan kepada seluruh pengguna situs, bisa melalui email, sosial
      media kami, maupun melalui situs ini secara langsung. Aturan yang baru
      akan mulai berlaku setelah pemberitahuan sudah terpublikasikan atau
      terkirim ke seluruh pengguna situs masjed.id. Kesepakatan di atas tidak
      berlaku apabila terdapat perubahan karena alasan hukum negara Indonesia,
      syarat dan ketentuan pada situs ini akan berubah menyesuaikan dengan
      peraturan pemerintah yang berlaku.
    </p>
    <p>
      Pengguna situs sangat dianjurkan untuk membaca dengan seksama segala
      ketentuan di bawah ini karena akan berdampak kepada hak dan kewajiban
      sebagai pengguna situs ini. Pertanyaan lainnya seputar masjed.id dapat
      dibaca di halaman FAQ atau anda menanyakan langsung kepada kami di
      masjed.id/hubungi-kami.
    </p>
    <h5>DEFINISI</h5>
    <ol type="a">
      <li>
        <strong>Penggalangan Dana (Social Crowdfunding)</strong> adalah suatu
        usaha pengumpulan kontribusi sukarela dalam bentuk uang dengan
        menggalang sumbangan dari berbagai Pihak untuk mendukung kegiatan
        sosial, kemanusiaan, kebudayaan, kesehatan, pendidikan, keagamaan, dan
        kegiatan lainnya.
      </li>
      <li>
        <strong>Platform</strong> adalah aplikasi dan situs internet masjed.id
        yang digunakan untuk memberikan fasilitas dan menyelenggarakan
        penggalangan dana melalui sistem elektronik yang dikelola dan disediakan
        oleh PT MASJED INDONESIA DIGITAL
      </li>
      <li>
        <strong>Pengguna</strong> adalah pengunjung dan pengguna terdaftar yang
        memanfaatkan layanan dan sistem elektronik masjed.id.
      </li>
      <li>
        <strong>Akun</strong> adalah user keanggotaan yang digunakan Pengguna
        untuk mengakses platform masjed.id dengan melakukan pendaftaran diri
        yang menyertakan informasi berupa username, email dan/atau nomor seluler
        dan kata sandi (password).
      </li>
      <li>
        <strong>Donasi</strong> adalah dana sumbangan yang dinyatakan dalam mata
        uang Rupiah.
      </li>
      <li>
        <strong>Campaign</strong> adalah suatu usaha penggalangan dana yang
        dilakukan oleh berbagai pihak yang bersifat sosial melalui bantuan
        donasi dalam kegiatan di bidang penanganan bencana kemanusiaan,
        lingkungan hidup, program kesehatan, pemberdayaan ekonomi, penyaluran
        zakat, infrastruktur, pendidikan dan beasiswa, difabel, panti asuhan dan
        rumah ibadah serta kegiatan sosial lainnya sepanjang tidak bertentangan
        dengan ketentuan perundang-undangan.
      </li>
      <li>
        <strong>Penerima</strong> Manfaat adalah pihak yang menerima donasi dari
        program penggalangan dana yang dibuat oleh masjed.id.
      </li>
      <li>
        <strong>Donatur</strong> adalah pihak yang memberikan donasi secara
        sukarela kepada calon Penerima Donasi yang didaftarkan oleh masjed.id.
      </li>
    </ol>
    <h5>PENYALURAN DONASI & BIAYA INFAQ PEMELIHARAAN</h5>
    <ol>
      <li>
        Donasi yang berhasil terkumpul akan disalurkan melalui Lembaga Amil
        kepada penerima manfaat.
      </li>
      <li>
        Biaya infaq pemeliharaan akan dikenakan kepada donatur ketika melakukan
        pembayaran melalui semua metode pembayaran yang ada di masjed.id sebesar
        Rp 4,500,-.
      </li>
    </ol>
    <h5>PENUTUP</h5>
    <p>
      Demikian ketentuan ini ditetapkan dan mengikat bagi Pengguna dan
      Pengunjung. Ketentuan ini sewaktu-waktu mengalami perubahan, modifikasi,
      dan pembaharuan untuk mengikuti perkembangan dan peraturan
      perundang-undangan yang berlaku. Segala perubahan, modifikasi, dan
      pembaharuan akan disampaikan kepada Pengguna atau Pengunjung melalui
      jaringan komunikasi yang tersedia dalam platform masjed.id.
    </p>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
div,
p {
  text-align: justify;
}
ol {
  li {
    padding: 5px 0px;
  }
}
</style>
